import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public async toggleSidebar(event: Event) {
        event.stopPropagation();
        await this.service.status.toggle('sidebarCollapsed');
    }

    public async closeMobileMenu() {
        if (window.innerWidth < 1024) {
            await this.service.status.toggle('navbar', false);
        }
    }

    public get sidebarCollapsed(): boolean {
        return !!(this.service.status as any).sidebarCollapsed;
    }

    public get desktopCollapsed(): boolean {
        return this.sidebarCollapsed && window.innerWidth >= 1024;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        const layoutClass = this.sidebarCollapsed ? "lg:justify-center" : "";
        if (this.isActive(link)) {
            return `group flex gap-x-2 items-center rounded-md bg-gray-100 px-2 py-1.5 text-[13px] font-medium text-indigo-600 ${layoutClass}`;
        }
        return `group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-indigo-600 ${layoutClass}`;
    }
}

export default ComponentNavSidebarComponent;